<template>
    <router-view v-if="$route.name==='stockdetail'"></router-view>
    <content-view
        class="slide"
        v-else
    >
        <template slot="header">
            <reset-search
                class="pb32 pt16"
                ref="pa"
                :form.sync="form"
            >
                <table class="wh-form wh-form_full">
                    <tbody>
                        <tr>
                            <td width="120">出库编号：</td>
                            <td>
                                <a-input
                                    v-model="form.serial"
                                    placeholder="请输入"
                                ></a-input>
                            </td>
                            <td width="120">大类：</td>
                            <td>
                                <a-select
                                    v-model="form.parent_id"
                                    placeholder="请选择"
                                    @change="parentChange"
                                >
                                    <a-select-option
                                        :value="item.id"
                                        v-for="item in parentList"
                                        :key="item.id"
                                        >{{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </td>
                            <td width="120">小类：</td>
                            <td>
                                <a-select
                                    v-model="form.small_category_id"
                                    placeholder="请选择"
                                >
                                    <a-select-option
                                        :value="item.id"
                                        v-for="item in brokeList"
                                        :key="item.id"
                                        >{{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </td>
                        </tr>
                        <tr>
                            <td width="100">商户帐号：</td>
                            <td>
                               <a-input
                                    v-model="form.useraccount"
                                    placeholder="请输入"
                                ></a-input>
                            </td>
                            <td width="100">提交时间：</td>
                            <td>
                                <a-range-picker v-model="form.orderTime" />
                            </td>
                            <td width="100">出库状态：</td>
                            <td>
                               <a-select
                                    v-model="form.status"
                                    placeholder="请选择"
                                >
                                    <a-select-option value="">全部 </a-select-option>
                                    <a-select-option value="3">已出库 </a-select-option>
                                    <a-select-option value="4">待出库</a-select-option>
                                </a-select>
                            </td>
                        </tr>
                        <tr>
                            <td
                                class="text-center"
                                colspan="6"
                            >
                                <a-button
                                    @click="reset"
                                    class="mr8"
                                >重 置</a-button>
                                <a-button
                                    type="primary"
                                    @click="search"
                                >查 询</a-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </reset-search>
        </template>
        <div class="bg-white pl32 pr32 pt32">
            <div class="slide-balance">
                <h4
                    class="slide-title"
                >出库列表</h4>
            </div>
            <a-table
                :columns="columns"
                :dataSource="sellList"
                bordered
                class="mt16"
                :pagination="pagination"
                :scroll="{x: true}"
                rowKey="id"
                @change="paginationChange"
            >
                <span
                    slot="orderstatus"
                    slot-scope="text, record"
                >
                
                   {{record.orderstatus == "4" ? "待出库" : "已出库"}}
                </span>
                <span
                    slot="action"
                    slot-scope="text, record"
                >
                    <!-- @click="$router.push({name:'slideAdd' ,query:{id:record.id}})" -->
                    <!-- :class="{forbidden:!$route.meta.role.knowEdits}" -->
                    <a
                        class="btn btn_text" 
                        @click="$router.push({name:'deliveryDetails' ,query:{serial:record.serial}})"
                        :class="{forbidden:!$route.meta.role.detail}"
                    >详情</a>
                </span>
            </a-table>
        </div>
    </content-view>
</template>

<script>
export default {
    name: "businessSlide",
    data() {
        return {
            form:{},
            bannerNumList: [{
                id:1,
                name:"1"
            },{
                id:2,
                name:"2"
            },{
                id:3,
                name:"3"
            },{
                id:4,
                name:"4"
            },{
                id:5,
                name:"5"
            },{
                id:6,
                name:"6"
            }],
            columns: [
               {
                    title: "序号",
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 70
                },
                {
                    title: "出库编号",
                    dataIndex: "serial",
                    width: 200,
                    
                },
                {
                    title: "大类",
                    dataIndex: "parent_category_name",
                    width: 150,
                    
                },
                {
                    title: "小类",
                    dataIndex: "category_name",
                    width: 150,
                    
                },
                {
                    title: "净重(KG)",
                    dataIndex: "real_weight",
                    width: 150,
                    
                },
                {
                    title: "车牌号码",
                    dataIndex: "drive_num",
                    width: 150,
                    
                },
                {
                    title: "司机姓名",
                    dataIndex: "drive_name",
                    width: 150,
                    
                },
                {
                    title: "提交时间",
                    dataIndex: "created_at",
                    width: 200
                },
                {
                    title: "出库状态",
                    scopedSlots: { customRender: "orderstatus" },
                    width: 100
                },
                {
                    title: "商户帐号",
                    dataIndex: "useraccount",
                    width: 200
                },
                {
                    title: "操作",
                    dataIndex: "",
                    scopedSlots: { customRender: "action" },
                    width: 160
                }
            ],
            sellList: [],
            parentList: [],
            brokeList: [],
            page: 1,
            limit: 10,
            pagination: {
                //默认当前页
                defaultCurrent: 1,
                defaultPageSize: 10,
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                showSizeChanger: true,
                total: 0
            },
            radioValue: "0"
        };
    },
    methods: {
        // 头部数据重置
        reset() {
            this.page = 1;
            this.limit = 10;
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.$refs.pa.reset();
            this.getList();
        },
        //查询
        search() {
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.page = 1;
            this.limit = 10;
            this.getList(true);
        },
        /**
         * 分页变化回调
         * @param pagination 当前分页器信息
         */
        paginationChange(pagination) {
            this.$set(this.pagination, "current", pagination.current);
            this.$set(this.pagination, "pageSize", pagination.pageSize);
            this.page = pagination.current;
            this.limit = pagination.pageSize;
            this.getList();
        },
        getList(status = false) {
            let date = this.form.orderTime;
            if (date && date.length > 0) {
                this.form.ctime_s = parseInt(
                    this.$moment(date[0])
                        .hour(0)
                        .minute(0)
                        .second(0)
                        .valueOf() / 1000
                );
                this.form.ctime_e = parseInt(
                    this.$moment(date[1])
                        .hour(23)
                        .minute(59)
                        .second(59)
                        .valueOf() / 1000
                );
            }else{
                delete this.form.ctime_s;
                delete this.form.ctime_e;
            }
            this.form.page = this.page;
            this.form.limit = this.limit;
            this.$api.order
                .sellList("",{
                    params:this.form
                })
                .then(res => {
                    this.sellList = res.data.list;
                    this.pagination.total = res.data.total * 1;
                    status
                    ? this.$message.success("共查询到" + res.data.total + "条信息")
                    : "";
                });
        },
        // 获取大类
        getParent(){
            this.$api.sortCategory.parentCategory().then(res => {
                this.parentList = res.data.list;
            })
        },
        // 获取小类
        getBroke(id){
            this.$api.sortCategory.brokeCategory({parent_id: id}).then(res => {
                this.brokeList = res.data.list;
            })
        },
        parentChange(val) {
            this.getBroke(val);
        }
    },
    mounted() {
        this.getList();
        this.getParent();
    },
    watch: {
        $route(val, oldVal) {
            if (val.name === "stockdetail") {
                this.page = 1;
                this.limit = 10;
                this.$set(this.pagination, "current", 1);
                this.$set(this.pagination, "pageSize", 10);
                this.getList();
            }
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.slide {
    &-balance {
        display: flex;
        justify-content: space-between;
    }
    &-title {
        color: $title-color-black-85;
        @include pxAndLh(16);
        font-weight: bold;
    }
    .image {
        height: 64px;
    }
}
</style>
